import React from 'react';
import '../components/grammar-page.css';
import { FaBookOpen, FaLightbulb } from 'react-icons/fa';

const DependentprepositionsExplanation = () => {
  return (
    <div className="grammar-explanation">
      <h2><FaBookOpen /> Grammar Focus: <strong>Dependent Prepositions</strong></h2>

      <h3><FaLightbulb /> What Are Dependent Prepositions?</h3>
      <p>
        Some <strong>adjectives</strong> and <strong>verbs</strong> in English are followed by <strong>specific prepositions</strong> — not just any preposition, but one that's "dependent" on the word before it.
      </p>
      <p>
        These combinations are fixed — you have to learn them together:
        <br /><em>interested <strong>in</strong> something</em> (not "interested on")
        <br /><em>angry <strong>at</strong> someone</em> (not "angry to")
      </p>

      <p>
        Using the <strong>wrong preposition</strong> may sound strange or change the meaning. Native speakers learn these combinations naturally — but as a learner, you need to memorize them.
      </p>

      <h3><FaLightbulb /> Common Adjective + Preposition Combinations</h3>

      <div className="grammar-flex-table">
        {[
          ['Adjective', 'Preposition', 'Example Sentence'],
          ['angry', 'at / with', "I'm angry <strong>at</strong> the delay. / She's angry <strong>with</strong> her brother."],
          ['bored', 'with / by', "He's bored <strong>with</strong> the movie. / I was bored <strong>by</strong> the lecture."],
          ['good / bad', 'at / for', "She's good <strong>at</strong> painting. / Smoking is bad <strong>for</strong> you."],
          ['interested', 'in', "They're interested <strong>in</strong> history."],
          ['afraid', 'of', "I'm afraid <strong>of</strong> spiders."],
          ['proud', 'of', "She's proud <strong>of</strong> her team."],
          ['similar', 'to', "This app is similar <strong>to</strong> Duolingo."],
          ['famous', 'for', "Paris is famous <strong>for</strong> its cafés."],
          ['worried', 'about', "He's worried <strong>about</strong> the test."],
          ['tired', 'of', "I'm tired <strong>of</strong> waiting."],
        ].map((row, index) => (
          <div key={index} className={`grammar-flex-row${index === 0 ? ' header' : ''}`}>
            {row.map((cell, i) => (
              <div key={i} className="grammar-cell" dangerouslySetInnerHTML={{ __html: cell }} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DependentprepositionsExplanation;
